export default {
  meta: {
    title: '模版管理',
  },
};
